import { SvgIcon } from '@mui/material';
import React from 'react';
const Warning = React.forwardRef((props, ref) => {
    return (React.createElement(SvgIcon, Object.assign({ width: '22', height: '19', viewBox: '0 0 22 19', fill: 'none' }, props, { ref: ref }),
        React.createElement("path", { xmlns: 'http://www.w3.org/2000/svg', d: 'M0 19L11 0L22 19H0ZM10 13H12V8H10V13ZM11 16C11.2833 16 11.521 15.904 11.713 15.712C11.9043 15.5207 12 15.2833 12 15C12 14.7167 11.9043 14.4793 11.713 14.288C11.521 14.096 11.2833 14 11 14C10.7167 14 10.4793 14.096 10.288 14.288C10.096 14.4793 10 14.7167 10 15C10 15.2833 10.096 15.5207 10.288 15.712C10.4793 15.904 10.7167 16 11 16Z' })));
});
export default Warning;
